const state = () => ({
  certificatetype:null,
  certificatetypes:[],
});
const getters = {
  certificatetype(state){
    return state.certificatetype
  },
  certificatetypes(state){
    return state.certificatetypes
  },
};
const  mutations =  {
  SET_CERTIFICATETYPE(state,data){
    state.certificatetype = data
  },
  SET_CERTIFICATETYPEs(state,data){
    state.certificatetypes = data
  },
};
const actions =  {
  serCertificateType({commit},data)  {
    commit("SET_CERTIFICATETYPE",data)
  },
  serCertificateTypes({commit},data)  {
    commit("SET_CERTIFICATETYPES",data)
  }
}

export default {
  namespaced: true,
  mutations,
  getters,
  state,
  actions,
};

